/** Client-safe area label derived from rule/check id (no raw checkId in portal DTO). */
export function clientSafeAreaLabelFromCheckId(checkId) {
    const base = checkId.replace(/\.(skipped|disabled|manager-exception|not-run)$/i, "");
    const segment = base.split(".").pop() ?? base;
    return segment
        .split(/[-_]/g)
        .filter((p) => p.length > 0)
        .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
        .join(" ");
}
function messageTag(message, tag) {
    return (message ?? "").toUpperCase().includes(`[${tag}]`);
}
export function dispositionForQualityCheck(check, qa) {
    if (!qa.completed) {
        return "NOT_RUN";
    }
    const id = check.checkId.toLowerCase();
    if (id.endsWith(".skipped") || messageTag(check.message, "SKIPPED")) {
        return "SKIPPED";
    }
    if (id.endsWith(".disabled") || messageTag(check.message, "DISABLED")) {
        return "DISABLED";
    }
    if (id.endsWith(".manager-exception") || messageTag(check.message, "MANAGER_EXCEPTION")) {
        return "MANAGER_EXCEPTION";
    }
    if (id.endsWith(".not-run") || messageTag(check.message, "NOT_RUN")) {
        return "NOT_RUN";
    }
    if (check.passed) {
        return "PASSED";
    }
    if (check.severity === "WARN") {
        return "WARNING";
    }
    if (check.severity === "INFO" || check.severity === "ADVISORY") {
        return "UNRESOLVED";
    }
    return "FAILED";
}
export function clientSafeMessageForDisposition(disposition) {
    switch (disposition) {
        case "PASSED":
            return "This area passed our readiness review.";
        case "FAILED":
            return "This area needs attention before treating the site as fully ready.";
        case "WARNING":
            return "This area completed with warnings.";
        case "SKIPPED":
            return "This check was skipped for this review.";
        case "DISABLED":
            return "This check is not active for your current plan or configuration.";
        case "MANAGER_EXCEPTION":
            return "This item was noted with a manager exception.";
        case "NOT_RUN":
            return "This check did not run for this review.";
        case "UNRESOLVED":
            return "This area needs clarification or follow-up.";
        default:
            return "This area needs review.";
    }
}
//# sourceMappingURL=report-governance-disposition.js.map